import { gql } from '@apollo/client/core';

export const GET_NEWS = gql`
  query GetNews($slug: String!) {
    news(filters: { slug: { ne: $slug } }) {
        id
        title
        short_description
        media {
            url
        }
        publish_start_date
        description
        news_category {
            name
        }
        slug
    }
  }
`;

export const GET_NEWS_BY_SLUG = gql`
  query GetNewsBySlug($slug: String!) {
    news(filters: { slug: { eq: $slug } }) {
      data {
        id
        title
        short_description
        media {
          url
        }
        publish_start_date
        description
        news_category {
          name
        }
        slug
      }
    }
  }
`;

export const GET_NEWS_PAGINATE = gql`
  query GetListNews($page: Int!, $pageSize: Int!, $filters: NewFiltersInput) {
    news_connection(
      filters: $filters
      pagination: { page: $page, pageSize: $pageSize }
      sort: ["createdAt:desc"]
    ) {
      nodes {
        documentId
        title
        slug
        short_description
        description
        publish_start_date
        news_category {
          documentId
          name
        }
        media {
          documentId
          name
          url
        }
      }
      pageInfo {
        page
        pageCount
        pageSize
        total
      }
    }
  }
`;